<button color="accent" class="m-menu" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
  <mat-icon>menu</mat-icon>
</button>
<mat-menu #menu="matMenu" xPosition="after" class="bg-primary">
  <div mat-menu-item>
    <img class="powered-by-logo" [src]="domainService.wlAssetURL + '/powered-by-header.png'" alt="" />
  </div>
  @for (item of navService.navItems; track item) {
    @let isNavVisible = navService.isSportVisible(item.name.toLowerCase(), "header") | async;
    @if (isNavVisible) {
      @if (item.name === "Casino") {
        <a (click)="navService.openCasino()" mat-menu-item>
          <span class="text-secondary">
            {{ item.name | translate }}
          </span>
        </a>
      } @else {
        <a [routerLink]="item.path" mat-menu-item>
          <span class="text-secondary">
            {{ item.name | translate }}
          </span>
        </a>
      }
    }
  }
</mat-menu>
